import { Alert } from "@mui/material";
import DialogBox from "./DialogBox";
import Button from "./Button";

type CancelDialogProps = {
    isOpen: boolean;
    onClose: () => void;
    onCancel: () => void;
};

const CancelDialog = ({ isOpen, onClose, onCancel }: CancelDialogProps) => {
    return (
        <DialogBox
            title="Are you sure you want to cancel?"
            isOpen={isOpen}
            onClose={onClose}
            className="max-w-lg"
        >
            <Alert severity="warning" className="items-center">
                All changes will be discarded.
            </Alert>
            <div className="flex justify-end gap-4 mt-10">
                <Button variant="transparent" type="button" onClick={onClose}>
                    Cancel
                </Button>
                <Button onClick={onCancel}>Discard changes</Button>
            </div>
        </DialogBox>
    );
};

export default CancelDialog;
